import { render, staticRenderFns } from "./Block.vue?vue&type=template&id=4b7b04fc&scoped=true&"
import script from "./Block.vue?vue&type=script&lang=ts&"
export * from "./Block.vue?vue&type=script&lang=ts&"
import style0 from "./Block.vue?vue&type=style&index=0&id=4b7b04fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7b04fc",
  null
  
)

export default component.exports